import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatCheckbox = createCustomElementWrapper('kat-checkbox', 'KatCheckbox', {
    'constraintLabel': 'constraint-label',
    'katAriaLabel': 'kat-aria-label',
    'katAriaLabelledby': 'kat-aria-labelledby',
}, {
    'onChange': 'change',
});
